import React, { useEffect, useState } from 'react';
import backgroundImage from '../../assets/background.jpg';
import { ReactComponent as PropacityLogo } from '../../assets/propacityplush.svg';
import MobileInput from '../../components/InputGroup/MobileInput';
import { Link } from 'react-router-dom';
import OTP from './OTP';

import SignupForm from './SignupForm';
import PaymentPlan from './PaymentPlan';
import Offers from './Offers';
import Coupons from './Coupons';
import { brokerSignup, insertTempEntry, sendBrokerOtpForLogin, sendTempOtpWithCompanyCode } from '../../services/public/public.service';
import { toast } from 'react-toastify';
import AppDownloadModal from './AppDownloadModal';
import OwnerEmployeeCheck from './OwnerEmployeeCheck';
import InputText from '../../components/InputGroup/InputText';
import NewUserSignup from './NewUserSignup';
import { SelectCompany } from './SelectCompany';
import OwnerNotify from './OwnerNotify';
import RequestSentModal from './Modal/RequestSentModal';
import { getDeviceInfo } from '../../helpers/helpers';


const Signup = () => {

    const [componentName, setComponentName] = useState('login')
    const [mobile, setMobile] = useState('');
    const [error, setError] = useState('');
    const [selectedPlan, setSelectedPlan] = useState('');
    const [code, setCode] = useState('');
    const [selectedOffer, setSelectedOffer] = useState({});
    const [appDownloadModal, setAppDownloadModal] = useState(false);
    const [isOwner, setIsOwner] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [loginError, setLoginError] = useState(false);
    const [requestId, setRequestId] = useState('');
    const [companies, setCompanies] = useState([]);
    const [isSignup, setIsSignup] = useState(false);
    const [ownerName, setOwnerName] = useState('')
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [deviceInfo, setDeviceInfo] = useState({});
    useEffect(() => {
        const load = async () => {
            getDeviceInfo().then(res => {
                console.log(res, 'response')
                setDeviceInfo(res)

            })
        }
        load()
    }, [])
    // sendTempOtpWithCompanyCode
    const handleSubmit = async () => {
        if (!mobile) {
            setError('Please enter mobile number.');
            return;
        } else {
            setError('')
        }
        try {

            // const res = await sendBrokerOtpForLogin({ mobile });
            const res = await insertTempEntry({ mobile, device_info: deviceInfo });
            if (res.data.status === 200) {
                toast.success(res.data.message);
                setRequestId(res.data.data?.request_id)
                setIsSignup(res.data.data?.signup);
                setComponentName('otp')
            }
        } catch (err) {
            console.log({ err });
            toast.error(<div>
                {err?.response?.data?.message}
                <p>{err?.response?.data?.data?.mobile}</p>
            </div>,
                {
                    autoClose: 5000,
                    closeOnClick: true,
                }
            )
        }
    }
    const handleSubmitLogin = async () => {
        if (!mobile || !companyCode) {
            setLoginError(true);
            return;
        } else {
            setLoginError(false)
        }
        try {
            const res = await sendTempOtpWithCompanyCode({ mobile, company_code: companyCode });
            if (res.data.status === 200) {
                toast.success(res.data.message);
                setComponentName('otp')
            }
        } catch (err) {
            console.log({ err });
            toast.error(<div>
                {err?.response?.data?.message}
                <p>{err?.response?.data?.data?.mobile}</p>
            </div>,
                {
                    autoClose: 5000,
                    closeOnClick: true,
                }
            )
        }
    }

    console.log(componentName, 'componentName')
    return (
        <div className={`${componentName === 'signupform' ? 'md:items-center items-start' : 'items-center'} flex flex-fill justify-center h-full overflow-y-auto overflow-x-hidden xl:!py-0`} style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            {componentName === 'login' && (<div className='bg-white rounded-xl md:max-w-[560px] md:basis-[560px] pt-[72px] pb-[72px] px-6 grow-0 shrink-0 w-11/12 shadow-shadowcard'>
                <div className='w-[300px] !table mx-auto'>
                    <div className='!mx-auto !table !mb-6'><PropacityLogo /></div>
                    <div className='text-textblack font-semibold text-xl leading-8'>Signup/Login</div>
                    <p className='text-black600'>Enter mobile number to get OTP</p>
                    {/* <div className='font-inter [&>*]:!border-0 !mt-6'>
                        <label className='text-sm font-medium text-black800 !mb-2'>Company Code<sup className='text-blue-900 !text-sm !top-0 font-medium'>*</sup></label>
                        <InputText
                            value={companyCode}
                            onChange={(e) => setCompanyCode(e.target.value)}
                            inputclass='!h-10'
                            placeholder={'Enter Company Code'}
                            error={(loginError && !companyCode) ? 'Please enter company code' : ''}
                        />
                    </div> */}
                    <div className='font-inter [&>*]:!border-0 !mt-4'>
                        {/* <label className='text-sm font-medium text-black800 !mb-2'>Mobile<sup className='text-blue-900 !text-sm !top-0 font-medium'>*</sup></label> */}
                        <MobileInput
                            value={mobile}
                            onChange={(e) => setMobile(e.phone)}
                            inputclass='!h-10'
                            dropdownDisable={true}
                            error={(loginError && !mobile) ? 'Please enter mobile number.' : ''}
                        />
                    </div>
                    <div className='!mt-6'>
                        <button className='w-100 shadow-inset-blue gradient-blue text-white text-base font-medium !rounded-lg !py-2' onClick={handleSubmit}>Continue</button>
                    </div>
                    <div className='!mt-6 text-black800 text-xs leading-5'>
                        By continuing, you agree to our
                        <a className='!text-blue-900 hover:!text-text-blue-900 cursor-pointer' href='https://propacity.com/terms-of-service' target='_blank'> Terms of Service </a> and
                        <a className='!text-blue-900 hover:!text-text-blue-900 cursor-pointer' href='https://propacity.com/privacy-policy' target='_blank'> Privacy Policy</a>.
                    </div>

                    {/* <div className='!mt-6 text-black800 text-xs leading-5'>
                        Not registered?
                        <a className='!text-blue-900 hover:!text-text-blue-900 cursor-pointer' onClick={() => setComponentName('signup')}> Signup here</a>
                    </div> */}
                    {/* <div className='mt-6 text-black800 text-xs leading-5'>
                        Already registered? <Link to='/login' className='!text-blue-900 hover:!text-text-blue-900 cursor-pointer font-semibold'>Log in</Link>
                    </div> */}
                </div>
            </div>
            )}
            {/* {componentName === 'signup' && <NewUserSignup mobile={mobile} setMobile={setMobile} handleSubmit={handleSubmit} setComponentName={setComponentName} />} */}
            {componentName === 'otp' && <OTP
                setComponentName={setComponentName}
                mobile={mobile}
                handleResendOTP={handleSubmit}
                setCompanies={setCompanies}
                requestId={requestId}
                isSignup={isSignup}
            />}
            {componentName === 'ownerCheck' && <OwnerEmployeeCheck setComponentName={setComponentName} setIsOwner={setIsOwner} />}
            {componentName === 'signupform' && <SignupForm
                setComponentName={setComponentName}
                userMobile={mobile}
                isOwner={isOwner}
                requestId={requestId}
                setEmpEmail={setEmail}
                setEmpName={setName}
            />}
            {componentName === 'paymentplan' && <PaymentPlan setComponentName={setComponentName} page='outer' setSelectedPlan={setSelectedPlan} selectedPlan={selectedPlan} />}
            {componentName === 'offers' &&
                <Offers
                    setComponentName={setComponentName}
                    page='outer'
                    selectedPlan={selectedPlan}
                    setCode={setCode}
                    code={code}
                    selectedOffer={selectedOffer}
                    setSelectedOffer={setSelectedOffer}
                />}
            {componentName === 'coupons' && <Coupons
                setComponentName={setComponentName}
                page='outer'
                selectedPlan={selectedPlan}
                setCode={setCode}
                code={code}
                selectedOffer={selectedOffer}
                setSelectedOffer={setSelectedOffer}
            />}

            {
                componentName === 'selectCompany' && <SelectCompany requestId={requestId} companies={companies} setComponentName={setComponentName} />
            }
            {
                componentName === 'ownerNotify' && <OwnerNotify
                    setComponentName={setComponentName}
                    name={name}
                    empEmail={email}
                    empMobile={mobile}
                    setOwnerNameForInfo={setOwnerName}
                />
            }
            {
                componentName === 'requestSent' && <RequestSentModal
                    name={ownerName}
                    setComponentName={setComponentName}
                    closeModal={() => {
                        setMobile('')
                        setComponentName('login')
                    }}
                />}

            {appDownloadModal && <AppDownloadModal show={appDownloadModal} closeModal={() => setAppDownloadModal(false)} />}

            <div className='md:flex hidden items-center justify-center md:flex-row flex-col gap-3 fixed bottom-0 left-0 right-0 z-10 bg-textblack text-white !py-2'>
                <p className='m-0 text-sm font-medium '>Kickstart your Real Estate journey today!</p>
                <button onClick={() => setAppDownloadModal(true)} className='text-sm shadow-white-btn-shadow bg-whtie font-medium !rounded-lg !border !border-black400 bg-white !py-2 text-textblack px-2.5'>Download Mobile App Now</button>

            </div>

        </div>

    )
}

export default Signup